/**
 * @file 价格处理工具函数
 */
import type {MemberLevelItem} from '@/services/commerce/membership/interface';

/**
 * 获取价格显示文本，升级时显示补差价，否则显示原价
 * @param level 会员等级信息
 * @param isUpgrade 是否升级
 * @returns 价格（分）
 */
export function getPrice(level: MemberLevelItem, isUpgrade: boolean): number {
    // 升级时显示补差价，否则显示原价
    return isUpgrade
        ? (level.upgradeInfo?.priceDiff ?? level.sku.upgradePrice)
        : level.sku.sellPrice;
}
